import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { useLayoutEffectIsomorphic } from '@chegg-ui/utils';
import { Container, ControlWrapper, ElementsList, ListItem, NextDoneButton, SLIDE_TRANSITION_INTERVAL } from './styles';
import ProgressBar from '../ProgressBar/ProgressBar';

var MultiStepContent = function MultiStepContent(_ref) {
  var children = _ref.children,
      currentSlide = _ref.currentSlide,
      onChangeSlide = _ref.onChangeSlide,
      onDone = _ref.onDone,
      onClose = _ref.onClose,
      className = _ref.className,
      dataTest = _ref['data-test'],
      ariaLabel = _ref['aria-label'],
      buttonDataTestId = _ref.buttonDataTestId,
      progressDataTestId = _ref.progressDataTestId;
  var totalSlides = children.length;
  var isLastSlide = currentSlide === totalSlides - 1;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      animatingSlide = _useState2[0],
      setAnimatingSlide = _useState2[1];

  var nextButtonRef = useRef(null);
  var timer = useRef(); // only called client-side in response to triggered slide change action

  useLayoutEffectIsomorphic(function () {
    if (timer.current) clearTimeout(timer.current);
    setAnimatingSlide(currentSlide);
    timer.current = setTimeout(function () {
      setAnimatingSlide(-1);
    }, SLIDE_TRANSITION_INTERVAL);
    return function () {
      /* istanbul ignore else */
      if (timer.current) clearTimeout(timer.current);
    };
  }, [currentSlide]);
  useEffect(function () {
    if (currentSlide >= totalSlides) onDone();
  }, [currentSlide]);

  var incrementSlide = function incrementSlide() {
    return onChangeSlide(currentSlide + 1);
  };

  var controlId = ariaLabel.split(/\s+/).join('-');
  var ref = useRef(null);

  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      event.stopPropagation();
      event.preventDefault();
      if (currentSlide === 0) onClose();
      incrementSlide();
    }
  };

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
    incrementSlide();
  };

  useEffect(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      return document.removeEventListener('click', handleClickOutside, true);
    };
  });
  return /*#__PURE__*/React.createElement(Container, {
    ref: ref,
    className: className,
    "data-test": dataTest,
    "aria-label": ariaLabel,
    role: 'tablist'
  }, /*#__PURE__*/React.createElement(ElementsList, {
    id: controlId,
    currentSlide: currentSlide,
    "aria-live": 'polite'
  }, children.map(function (child, index) {
    var isActive = currentSlide === index;
    var isVisible = isActive || currentSlide === animatingSlide;
    return /*#__PURE__*/React.createElement(ListItem, {
      id: "gallery-item-".concat(index),
      role: "tab",
      "aria-label": "".concat(index + 1, " of ").concat(totalSlides),
      key: index,
      "aria-hidden": !isActive,
      visible: isVisible,
      order: index,
      onClick: handleClick
    }, child);
  })), /*#__PURE__*/React.createElement(ControlWrapper, null, /*#__PURE__*/React.createElement(ProgressBar, {
    max: totalSlides,
    current: currentSlide,
    description: ariaLabel,
    "data-test": progressDataTestId
  }), isLastSlide ? /*#__PURE__*/React.createElement(NextDoneButton, {
    onClick: incrementSlide,
    ref: nextButtonRef,
    "data-test": buttonDataTestId
  }, "Done") : /*#__PURE__*/React.createElement(NextDoneButton, {
    onClick: incrementSlide,
    ref: nextButtonRef,
    "data-test": buttonDataTestId
  }, "Next")));
};

MultiStepContent.displayName = 'MultiStepContent';
export default MultiStepContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/MultiStepContent/MultiStepContent.js
// module id = 5594
// module chunks = 11